import { Col, Dropdown, MenuProps, Row } from 'antd';
import { DropdownButtonProps } from 'antd/es/dropdown';
import { ItemType } from 'antd/es/menu/interface';
import React, {
  memo,
  ReactElement,
  useCallback,
  useMemo,
  useState,
} from 'react';

import { PrinterIcon, PrinterWhiteIcon } from 'assets/svg';
import { icons } from 'utils/constants/icons';

type IItemType = {
  label: string;
  handleExport: () => void;
} & ItemType;

export type TMenuPropsCustom = {
  items: IItemType[];
} & Omit<MenuProps, 'items'>;

export type IExportOptionsButton = {
  menuProps: TMenuPropsCustom;
} & DropdownButtonProps;

const { CaretDownOutlined } = icons;

export const RewardOptionsButton = memo(
  ({ menuProps, ...passProps }: IExportOptionsButton) => {
    const [itemActive, setItemActive] = useState({} as IItemType);
    const [isHoveredLeft, setIsHoveredLeft] = useState(false);
    const [isHoveredRight, setIsHoveredRight] = useState(false);

    const menuPropsCustom = useMemo(() => {
      return {
        ...menuProps,
        items: menuProps.items.map((item, index) => {
          if (index === 0) setItemActive(item);

          const { handleExport, ...others } = item;
          return { ...others, onClick: () => setItemActive(item) };
        }),
      } as MenuProps;
    }, [menuProps]);

    const handleOnClick = useCallback(() => {
      itemActive.handleExport();
    }, [itemActive]);

    const handleMouseEnterLeft = () => {
      console.log('handleMouseEnterLeft');
      setIsHoveredLeft(true);
    };

    const handleMouseLeaveLeft = () => {
      console.log('handleMouseLeaveLeft');
      setIsHoveredLeft(false);
    };

    const handleMouseEnterRight = () => {
      console.log('handleMouseEnterRight');
      setIsHoveredRight(true);
    };

    const handleMouseLeaveRight = () => {
      console.log('handleMouseLeaveRight');
      setIsHoveredRight(false);
    };

    return (
      <Dropdown.Button
        menu={menuPropsCustom}
        className={`mt-[4px] border-solid border-[1px] rounded-[6px]`}
        icon={<CaretDownOutlined className="text-[#FFFFFF]" />}
        buttonsRender={([leftButton, rightButton]) => [
          React.cloneElement(leftButton as ReactElement, {
            className: `rounded-l-md border-r p-0 h-auto w-[150px]`,
            onMouseEnter: handleMouseEnterLeft,
            onMouseLeave: handleMouseLeaveLeft,
            style: {
              backgroundColor: isHoveredLeft ? '#e0c196' : '#C9A46D',
              borderColor: '#FFFFFF',
            },
          }),
          React.cloneElement(rightButton as ReactElement, {
            className: 'rounded-r-md border-l border-[#FFFFFF] p-0 h-auto',
            onMouseEnter: handleMouseEnterRight,
            onMouseLeave: handleMouseLeaveRight,
            style: {
              backgroundColor: isHoveredRight ? '#e0c196' : '#C9A46D',
              borderColor: '#FFFFFF',
            },
          }),
        ]}
        onClick={handleOnClick}
        {...passProps}
      >
        <Row
          gutter={[10, 0]}
          justify={'start'}
          align={'middle'}
          className="py-[8px]"
        >
          <Col>
            <PrinterWhiteIcon
              className={`printer-icon ${passProps.disabled && 'printer-icon:svg-'}`}
            />
          </Col>
          <Col>
            <p
              className="leading-[19.6px] font-bold text-[#FFFFFF]"
              // className={`leading-[19.6px] font-bold text-[#00538F] ${passProps.disabled && 'text-[white]'}`}
            >
              {itemActive.label}
            </p>
          </Col>
        </Row>
      </Dropdown.Button>
    );
  },
);
